import React from 'react'
import StripeModal from '../StripeModal'

import './index.scss'

const UbliqueContainer = ({ children, stripeModal = null }) => {
  return (
    <div className='ublique-container-template'>
      <>{children}</>
      {stripeModal?.showModal && <StripeModal stripeModal={stripeModal} />}
    </div>
  )
}

export default UbliqueContainer
